import React, { useEffect, useContext } from 'react';
import Button from '../../../../components/UI/Button';
import css from './OfferAccepted.module.scss';
import { getPlanNameText } from '../helpers';
import TaskList from '../UI/TaskList';
import LegalText from '../UI/LegalText';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';
import { useToggles } from '../../../../state/toggles';
import { planPrices } from '../../../../utils/prices';

export default function OfferAccepted({ planName, registrationToken, answer }) {
  const { analytics } = useContext(AnalyticsContext);
  const toggles = useToggles();
  const plans = planPrices(toggles);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Credit Application Offer Accepted');
  }, []);

  const submitAcceptedAnswer = () => {
    answer({
      accessToken: registrationToken,
      questions: ['credit_application'],
      answers: [
        { credit_accepted: true, credit_decision: 'approved_by_processor' }
      ]
    });
  };

  const planNameText = getPlanNameText(planName);
  const planPrice = plans[planName];

  const tasks = [
    { completed: true, text: 'Create a Greenlight account' },
    { completed: true, text: 'Apply for the Family Cash Card' },
    { completed: false, text: 'Link your payment account' }
  ];

  return (
    <div>
      <h1>One last step...</h1>
      <img
        className={css.applicationSubmissionImage}
        alt="Family Cash Card Banner"
        src="/static/family-cash-card-banner.svg"
      />
      <h2>
        {`Link your payment account to start using ${planNameText} and receive
        your credit card.`}
      </h2>
      <TaskList tasks={tasks} />
      <Button
        text="Next"
        onClick={() => {
          analytics.trackEvent('Credit Action', {
            eventProps: {
              type: 'Next',
              page: 'Credit Application Offer Accepted'
            }
          });
          submitAcceptedAnswer();
        }}
      />
      <LegalText>
        {`After your 1-month free trial, your plan is $${planPrice}/mo. Your credit card will be shipped once your payment account has been added.`}
      </LegalText>
    </div>
  );
}
